package com.yogaaicoach.pages.trainingprogram

import com.yogaaicoach.pages.dashboard.mainGoalDisplayName
import com.yogaaicoach.scope
import kotlinx.coroutines.launch
import react.FC
import react.Props
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.div
import react.useEffectOnce
import react.useState
import web.cssom.ClassName

internal external interface UpdateGoalPageProps : Props {
    var viewModel: UpdateTrainingViewModel
    var onDone: () -> Unit
}

private data class UpdateGoalContent(val goal: MainGoal, val image: String, val description: String)

private val goalContents = listOf(
    UpdateGoalContent(
        MainGoal.PHYSICAL_STRENGTH,
        "physical_strength.jpg",
        "Focuses on building and enhancing muscle strength, endurance, and overall physical power. \nThis includes upper body, core, and lower body strength, as well as muscle tone. \n\nIdeal for those looking to improve their physical fitness and challenge their body through dynamic movements and poses."
    ),
    UpdateGoalContent(
        MainGoal.BALANCE_AND_COORDINATION,
        "balance_and_coordination.jpg",
        "Emphasizes improving balance, stability, and coordination through controlled movements and poses. \nThis group helps enhance body awareness and control. \n\nSuitable for those wanting to improve their physical equilibrium and precision in movements."
    ),
    UpdateGoalContent(
        MainGoal.POSTURE_AND_ALIGNMENT,
        "posture_and_alignment.jpg",
        "Concentrates on improving body posture, alignment, and structural integrity. \nThis group focuses on proper alignment in poses to prevent injuries and correct postural imbalances. \n\nSuitable for those looking to enhance their posture, reduce pain, and improve overall body mechanics."
    ),
    UpdateGoalContent(
        MainGoal.MOBILITY_AND_FLEXIBILITY,
        "mobility_and_flexibility.jpg",
        "Focuses on increasing joint mobility, flexibility, and range of motion. \nThis group includes deep stretching, gentle twists, and flexibility exercises to improve overall mobility and prevent stiffness. \n\nIdeal for those aiming to enhance their flexibility and maintain joint health."
    ),
)

internal val UpdateGoalPage = FC<UpdateGoalPageProps> { props ->
    var selectedGoals by useState(props.viewModel.selectedGoals.value)

    useEffectOnce {
        scope.launch { props.viewModel.selectedGoals.collect { selectedGoals = it } }
    }

    div {
        className = ClassName("wizard-page wizard-page-has-bottom-bar")

        PageTitleSection(
            "Choose your main focus areas",
            "Select the key areas you want to concentrate on in your yoga practice."
        )

        div {
            className = ClassName("wizard-list")
            goalContents.forEach { content ->
                val displayName = mainGoalDisplayName(content.goal.name)
                AddTrainingRow(content.image, displayName, content.description, selectedGoals.contains(content.goal)) {
                    props.viewModel.toggleSelectedGoal(content.goal)
                }
            }
        }
    }

    div {
        className = ClassName("wizard-bottom-bar")
        button {
            className = ClassName("outlined-button")
            disabled = selectedGoals.isEmpty()
            onClick = { props.onDone() }
            +"Done"
        }
    }
}
